import { ThemeProvider } from '@emotion/react'
import {
  BrowserRouter,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";
import { AppWrapper, ContentWrapper } from './App.styles';
import { NavPane, NavPaneMobile } from 'src/components/NavPane';
import ContentPage from 'src/layouts/ContentPage';
import theme from "./theme";



const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <AppWrapper>
        <NavPane />
        <NavPaneMobile />
        <ContentWrapper>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/articles" replace />} />
              <Route path="articles/:slug" element={<ContentPage contentType="articles"/>} />
              <Route path="articles" element={<ContentPage contentType="articles"/>} />
              <Route path="resume" element={<h2>Resume</h2>} />
              <Route path="about" element={<h2>About</h2>} />
              <Route path="reference/:slug" element={<ContentPage contentType="reference"/>} />
              <Route path="reference/" element={<ContentPage contentType="reference"/>} />
              <Route path="tools/:slug" element={<ContentPage contentType="tools"/>} />
              <Route path="tools/" element={<ContentPage contentType="tools"/>} />
              <Route path="how-to" element={<h2>How To</h2>} />
              <Route path="projects" element={<h2>Projects</h2>} />
              <Route path="404" element={<h2>404</h2>} />
              <Route
                  path="*"
                  element={<Navigate to="/404" replace />}
              />
            </Routes>
          </BrowserRouter>
        </ContentWrapper>
      </AppWrapper>
    </ThemeProvider>
  );
}

export default App;
